import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  style: {"width":"100%"},
  class: "py-1"
}
const _hoisted_2 = { class: "icon-container center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "fs-11 pr-1" }
const _hoisted_5 = {
  key: 0,
  class: "fs-11"
}
const _hoisted_6 = { class: "fs-smaller grey1-grey1-color center-x" }
const _hoisted_7 = { class: "fw-b center-x" }
const _hoisted_8 = { class: "fs-smaller grey1-grey1-color" }
const _hoisted_9 = { class: "fw-b" }
const _hoisted_10 = {
  key: 0,
  class: "fw-b ml-1"
}
const _hoisted_11 = {
  key: 1,
  class: "fw-b ml-1"
}

import { IonCol, IonIcon, IonRow } from "@ionic/vue";

import ButtonBase from "@/components/button/ButtonBase.vue";
import SkeletonBase from "@/components/various/SkeletonBase.vue";
import HighlightBox from "@/components/card/HighlightBox.vue";

import { openReadOnly } from "@/functions/modal";
import { convertNumberWithComma } from "@/functions/converter";

import { ION_VARIANT } from "@/types/enum/ionicEnum";
import { OrderDetailsEntryProps } from "@/types/props";
import { HIGHLIGHT_COLOR, HIGHLIGHT_MESSAGE } from "@/types/enum/propEnum";
import convertFormat from "../../functions/luxon";
import { DATE_TIME_FORMAT } from "@/types/enum/luxonEnum";
import { DateTime } from "luxon";
import { computed } from "vue";
import { CURRENCY_EUR } from "@/assets/variables";
import { PROMOTION_TYPE } from "@/types/enum/notification";


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderDetailsEntry',
  props: {
    entry: {},
    edit: { type: Boolean },
    loading: { type: Boolean, default: false },
    skeletonVariants: {},
    full: { type: Boolean },
    promotionAmountStep: {}
  },
  emits: ["edit", "convertToPromotion"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const handleEditClick = (event: TouchEvent | MouseEvent): void => {
    event.stopPropagation()
    emit('edit')
}

const expired = computed<boolean>(() => {
    if (!props.entry || !props.entry.promotion || !props.entry.promotion.validUntil) return false
    return DateTime.fromISO(props.entry.promotion.validUntil).diffNow('minutes').minutes < 0
})

const showPromotionHint = computed(() => {
    const { entry, promotionAmountStep } = props;
    return !entry?.isPromotion
        && entry?.item.promotion
        && promotionAmountStep
        && entry.quantity < promotionAmountStep                                  // ticket #363 → comment #27
        && entry.item.promotion.promotionType !== PROMOTION_TYPE.BONUS_FLEXIBLE  // ticket #363 → comment #27
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.entry && __props.entry.item)
      ? (_openBlock(), _createBlock(_unref(IonRow), {
          key: 0,
          class: _normalizeClass({ 'promotion-border-top promotion-border-inline' : showPromotionHint.value })
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCol), {
              size: "2",
              class: "center px-1",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(openReadOnly)(__props.entry.item)))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(SkeletonBase, {
                    show: __props.loading,
                    variants: __props.skeletonVariants
                  }, {
                    default: _withCtx(() => [
                      (__props.entry.item.imageLink)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            alt: "",
                            src: (__props.entry.item.imageLink.startsWith('/')) ? `https://app.octopusorder.com${__props.entry.item.imageLink}` : __props.entry.item.imageLink,
                            style: {"max-height":"100%"}
                          }, null, 8, _hoisted_3))
                        : (_openBlock(), _createBlock(_unref(IonIcon), {
                            key: 1,
                            src: "assets/icon/item.svg",
                            class: "max-size purple-purple-color"
                          }))
                    ]),
                    _: 1
                  }, 8, ["show", "variants"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(IonCol), {
              class: "center-x flex-d-c",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(openReadOnly)(__props.entry.item)))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonRow), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonCol), { class: "p-0 fw-b" }, {
                      default: _withCtx(() => [
                        _createVNode(SkeletonBase, {
                          show: __props.loading,
                          variants: __props.skeletonVariants
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(__props.entry.item.name), 1)
                          ]),
                          _: 1
                        }, 8, ["show", "variants"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (__props.entry.isPromotion)
                  ? (_openBlock(), _createBlock(_unref(IonRow), { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonCol), {
                          size: "auto",
                          class: "pt-1 p-0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(HighlightBox, {
                              color: _unref(HIGHLIGHT_COLOR).CORAL
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t(`enumT.${_unref(HIGHLIGHT_MESSAGE).PROMOTION}`)), 1)
                              ]),
                              _: 1
                            }, 8, ["color"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_unref(IonRow), null, {
                  default: _withCtx(() => [
                    (__props.entry.promotion && __props.entry.promotion.validUntil)
                      ? (_openBlock(), _createBlock(_unref(IonCol), {
                          key: 0,
                          size: "auto",
                          class: "ion-align-items-center pb-0 pt-1 pl-0 d-flex"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('object.validUntil')) + ": ", 1),
                            (!expired.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(convertFormat)(__props.entry.promotion.validUntil, 'iso', _unref(DATE_TIME_FORMAT).DE_SHORT)), 1))
                              : (_openBlock(), _createBlock(HighlightBox, {
                                  key: 1,
                                  color: _unref(HIGHLIGHT_COLOR).CORAL
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('object.expired')), 1)
                                  ]),
                                  _: 1
                                }, 8, ["color"]))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonRow), { class: "mt-1" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonCol), { class: "fs-smaller grey1-grey1-color p-0" }, {
                      default: _withCtx(() => [
                        _createVNode(SkeletonBase, {
                          show: __props.loading,
                          variants: __props.skeletonVariants
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(__props.entry.item.packaging), 1)
                          ]),
                          _: 1
                        }, 8, ["show", "variants"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonRow), { class: "mt-1" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonCol), { class: "fs-smaller grey1-grey1-color p-0" }, {
                      default: _withCtx(() => [
                        _createVNode(SkeletonBase, {
                          show: __props.loading,
                          variants: __props.skeletonVariants
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('label.articleNo')) + ": " + _toDisplayString(__props.entry.item.itemNumber), 1)
                          ]),
                          _: 1
                        }, 8, ["show", "variants"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (__props.edit)
              ? (_openBlock(), _createBlock(_unref(IonCol), {
                  key: 0,
                  size: "auto",
                  class: "center-y"
                }, {
                  default: _withCtx(() => [
                    _createVNode(ButtonBase, {
                      color: _unref(ION_VARIANT).GREY_4,
                      class: "round-button grey1-grey1-color inherit-color no-shadow",
                      style: {"width":"50px","height":"50px"},
                      onClick: handleEditClick
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonIcon), {
                          src: "assets/icon/pencil.svg",
                          class: "round-button-icon"
                        })
                      ]),
                      _: 1
                    }, 8, ["color"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["class"]))
      : _createCommentVNode("", true),
    (__props.entry && __props.entry.item)
      ? (_openBlock(), _createBlock(_unref(IonRow), {
          key: 1,
          class: _normalizeClass(["stacked-cols", { 'promotion-border-inline' : showPromotionHint.value }])
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCol), {
              size: "2",
              class: "fixed-width-xxs-screen",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(openReadOnly)(__props.entry.item)))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('object.amount')), 1),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(SkeletonBase, {
                    show: __props.loading,
                    variants: __props.skeletonVariants,
                    class: "skeleton-fw-b"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(__props.entry.quantity), 1)
                    ]),
                    _: 1
                  }, 8, ["show", "variants"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(IonCol), {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(openReadOnly)(__props.entry.item)))
            }, {
              default: _withCtx(() => [
                (Number(__props.entry.item.price))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('object.price')), 1),
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(SkeletonBase, {
                          show: __props.loading,
                          variants: __props.skeletonVariants,
                          class: "skeleton-fw-b"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(convertNumberWithComma)(Number(__props.entry.item.price).toFixed(3))) + " " + _toDisplayString(_unref(CURRENCY_EUR)), 1)
                          ]),
                          _: 1
                        }, 8, ["show", "variants"])
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["class"]))
      : _createCommentVNode("", true),
    (__props.entry && __props.entry.item && showPromotionHint.value)
      ? (_openBlock(), _createBlock(_unref(IonRow), {
          key: 2,
          class: "stacked-cols",
          style: {"background-color":"var(--ion-color-coral)","align-items":"center","color":"white"}
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCol), {
              class: "fixed-width-xxs-screen",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (emit('convertToPromotion')))
            }, {
              default: _withCtx(() => [
                (__props.promotionAmountStep && __props.entry.quantity < __props.promotionAmountStep)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(SkeletonBase, {
                        show: __props.loading,
                        variants: __props.skeletonVariants,
                        class: "skeleton-fw-b"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('messages.cart.upgradeToPromotion', { amount: __props.promotionAmountStep - __props.entry.quantity, shortTitle: __props.entry.item.promotion?.shortTitle })), 1)
                        ]),
                        _: 1
                      }, 8, ["show", "variants"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createVNode(SkeletonBase, {
                        show: __props.loading,
                        variants: __props.skeletonVariants,
                        class: "skeleton-fw-b"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('messages.cart.convertToPromotion')), 1)
                        ]),
                        _: 1
                      }, 8, ["show", "variants"])
                    ]))
              ]),
              _: 1
            }),
            _createVNode(_unref(IonCol), {
              size: "auto",
              class: "py-0"
            }, {
              default: _withCtx(() => [
                _createVNode(ButtonBase, {
                  class: "round-button inherit-color no-shadow",
                  style: {"width":"50px","height":"50px"},
                  onClick: _cache[5] || (_cache[5] = ($event: any) => {emit('convertToPromotion');}),
                  color: _unref(ION_VARIANT).PINK
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), {
                      src: "assets/icon/cart-promo-outline.svg",
                      class: "round-button-icon"
                    })
                  ]),
                  _: 1
                }, 8, ["color"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})